define('event',[],function() {
  return {
    subscribers: function() {
      if (!this._subscribersMap) {
        this._subscribersMap = {};
      }
      return this._subscribersMap;
    },

    subscribe: function(name, callback) {
      var subscribers = this.subscribers();

      if (!subscribers[name]) {
        subscribers[name] = [callback];
      } else {
        subscribers[name].push(callback);
      }
    },

    unsubscribe: function(name, callback) {
      var subscribers = this.subscribers()[name];
      if (subscribers) {
        for (var i = 0; i < subscribers.length; i++) {
          if (subscribers[i] === callback) {
            subscribers.splice(i, 1);
            break;
          }
        }
      }
    },

    monitor: function(name, callback) {
      if (!callback()) {
        var
          ctx = this,
          fn = function() {
            if (callback.apply(callback, arguments)) {
              ctx.unsubscribe(name, fn);
            }
          };
        this.subscribe(name, fn);
      }
    },

    clear: function(name) {
      delete this.subscribers()[name];
    },

    fire: function(name) {
      var subscriber,
        args = Array.prototype.slice.call(arguments, 1),
        subscribers = this.subscribers()[name];

      if (subscribers) {
        for (var i = 0; i < subscribers.length; i++) {
          subscriber = subscribers[i];
          if (subscriber) {
            subscriber.apply(this, args);
          }
        }
      }
    }
  };
});

